import { authConstants, uriConstants, mainConstants, govCertapplyConstants } from '../../constants'
import { authService, defaultService } from '../../services'
import { alertActions,userinfoActions } from '../'
import { errorMessages } from '../../messages'
import history from '../../../route/history'
import moment from 'moment'
import { commons } from '../../../hook/common'
import * as Common from '../../../assets/js/common.js'
import authHeader from '../../../module/auth-header'
import { constant } from 'lodash'
import { isMobile } from 'react-device-detect'
import { useDispatch } from 'react-redux'
import common from '../../reducers/common.reducer'

export const authActions = {
  logIn,
  logInCorp,
  logOut,
  getCurrentUser,
  uploadPushInfo,

  //아이디찾기
  getFindUserId,
  getFindPassword,
  resetFindInfo,

  /**간편로그인 */
  passLogin,
  pinNumReset,

  /**카카오로그인 */
  passkakaoLogin,
  mobileKakaoLogin,

  /**네이버로그인 */
  passnaverLogin,
  mobileNaverLogin,

  /**공동인증서 로그인 */
  passCrtfctfLogin,
  passCrtfctfLoginIos,

  /**디지털 원패스 */
  callDgtOnePass,
  passonepassLogin,

  /**qr 생성 */
  qrMakeImg,
  qrLoginCheck,

  /**간편로그인 */
  simplLogin,

  /**기기 고유번호 확인 */
  checkUUID,

  /** 로그인한 사용자 정보 가져오기 */
  getDeviceId,
  passCrtfctfLoginTest,

  /** 패스워드 인증 **/
  showPwdPopup,
  checkPwd,
}

/**
 * 로그인
 * @param userName
 * @param password
 * @returns {function(*): void}
 */
function logIn(userName, password, isSaveId = false) {
  return (dispatch) => {
    dispatch(apiAction(authConstants.LOGIN_REQUEST))
    console.log(userName.endsWith('_admin'))
    authService.logIn(userName, password).then(
      (response) => {
        if (!response.data?.payload?.memberId) {
          dispatch(loginFail(response))
          return
        }

        //강제정지 된 아이디로 로그인 접근 시
        if (response.data?.payload?.statusCd == 'S') {
          dispatch(loginState(response))
          return
        }

        console.log('!!!!!!!!!!!!!!!!!!')
        console.log(JSON.stringify(response.data))
        console.log('!!!!!!!!!!!!!!!!!!')
        if (Common.getDeviceType() === 'MobileApp') {
          window.M.data.storage('memberId', response.data.payload.memberId)
        }
        localStorage.setItem('user', JSON.stringify(response.data))
        localStorage.setItem('groupCode', JSON.stringify(response.data.payload.groupCode))

        if (isSaveId) {
          localStorage.setItem('saveId', response.data?.payload?.memberId)
          localStorage.setItem('lastLogin', moment().format('YYYYMMDD'))
        } else {
          localStorage.removeItem('saveId')
          localStorage.removeItem('lastLogin')
        }

        if (commons.isMobile()) {
          //push 토큰 조회
          window.ReactNativeWebView.postMessage(JSON.stringify({ storage: 'fcmToken' }))
        }
        // ptl_member_app 수정
        // if (isMobile) {
        if (Common.getDeviceType() == 'MobileApp') {
          // 로컬에서 모바일모드로 보면 에러가 발생해서 만든 예외처리이다.
          try {
            dispatch(updateMemberApp(window.M.info.device('uuid'), response.data.payload.memberId, 'Y'))
          } catch (e) {
            if (e.name === 'RangeError') {
            } else {
              throw e
            }
          }
        }

        document.location.href = '/'
      },
      (error) => {
        dispatch(apiAction(authConstants.LOGIN_FAILURE, error))
        dispatch(loginFail(error))
      },
    )
  }

  function loginFail(error) {
    return alertActions.success({
      title: null,
      message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
      params: {
        type: 'SUCCESS',
        callback: () => {
          history.replace('/loginIntro')
        },
      },
    })
  }

  //강제정지된 아이디로 로그인 접근 시
  function loginState(response) {
    return alertActions.success({
      title: '오류',
      message: response.data?.payload?.length > 0 ? response.data?.payload : errorMessages.statusError,
      params: {
        type: 'SUCCESS',
        callback: () => {
          history.replace('/')
        },
      },
    })
  }
}

/**
 * 로그인 법인회원
 * @param userName
 * @param password
 * @returns {function(*): void}
 */
function logInCorp(userName, password, isSaveId = false) {
  return (dispatch) => {
    dispatch(apiAction(authConstants.LOGIN_REQUEST))

    authService.logInCorp(userName, password).then(
      (response) => {
        if (!response.data?.payload?.memberId) {
          dispatch(loginCorpFail(response))
          return
        }

        //강제정지 된 아이디로 로그인 접근 시
        if (response.data?.payload?.statusCd == 'S') {
          dispatch(loginState(response))
          return
        }

        console.log('!!!!!!!!!!!!!!!!!!')
        console.log(JSON.stringify(response.data))
        console.log('!!!!!!!!!!!!!!!!!!')
        localStorage.setItem('user', JSON.stringify(response.data))
        localStorage.setItem('groupCode', JSON.stringify(response.data.payload.groupCode))

        if (isSaveId) {
          localStorage.setItem('saveId', response.data?.payload?.memberId)
          localStorage.setItem('lastLogin', moment().format('YYYYMMDD'))
        } else {
          localStorage.removeItem('saveId')
          localStorage.removeItem('lastLogin')
        }

        if (commons.isMobile()) {
          //push 토큰 조회
          window.ReactNativeWebView.postMessage(JSON.stringify({ storage: 'fcmToken' }))
        }

        // ptl_member_app 수정
        // if (isMobile) {
        if (Common.getDeviceType() == 'MobileApp') {
          // 로컬에서 모바일모드로 보면 에러가 발생해서 만든 예외처리이다.
          try {
            dispatch(updateMemberApp(window.M.info.device('uuid'), response.data.payload.memberId, 'Y'))
          } catch (e) {
            if (e.name === 'RangeError') {
              console.log('RangeError')
            } else {
              throw e
            }
          }
        }

        document.location.href = '/'
      },
      (error) => {
        dispatch(apiAction(authConstants.LOGIN_FAILURE, error))
        dispatch(loginCorpFail(error))
      },
    )
  }

  function loginCorpFail(error) {
    return alertActions.success({
      title: null,
      message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
      params: {
        type: 'SUCCESS',
        callback: () => {
          history.replace('/loginIntro')
        },
      },
    })
  }

  //강제정지된 아이디로 로그인 접근 시
  function loginState(response) {
    return alertActions.success({
      title: '오류',
      message: response.data?.payload?.length > 0 ? response.data?.payload : errorMessages.statusError,
      params: {
        type: 'SUCCESS',
        callback: () => {
          history.replace('/')
        },
      },
    })
  }
}
/**
 * 로그인 사용자 정보 조회
 * @returns {function(*): void}
 */
function getCurrentUser() {
  return (dispatch) => {
    dispatch(apiAction(authConstants.USER_INFO_REQUEST))

    authService.getCurrentUser().then(
      (response) => {
        dispatch(apiAction(authConstants.USER_INFO_SUCCESS, response))
      },
      (error) => {
        dispatch(apiAction(authConstants.USER_INFO_FAILURE, error))
        dispatch(apiError(error))
      },
    )
  }
}

/**
 * 푸시정보 등록
 * @returns {function(*): void}
 */
function uploadPushInfo(param) {
  return (dispatch) => {
    dispatch(apiAction(authConstants.PUSH_INFO_REQUEST))

    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + uriConstants.PUSH_INFO,
        params: param,
      })
      .then(
        (response) => {
          dispatch(apiAction(authConstants.PUSH_INFO_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(authConstants.PUSH_INFO_FAILURE, error))
        },
      )
  }
}

/**
 * 로그아웃
 * @returns {function(*): void}
 */
function logOut(replacePath) {
  return (dispatch) => {
    authService.logOut().then(
      (response) => {
        dispatch(success())
        //기존소스
        // history.replace("/");
        history.replace(!replacePath ? '/' : replacePath)
      },
      (error) => {
        dispatch(apiError(error))
      },
    )
  }
  function success() {
    return {
      type: authConstants.LOGOUT,
    }
  }
}

/**
 * 아이디 찾기
 * @param type  : email or phone
 * @param params : JSON object
 */
function getFindUserId(type, params, gbn) {
  return (dispatch) => {
    dispatch(apiAction(authConstants.FIND_REQUEST))

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)
    paramStr.length > 0 && (paramStr = '?' + paramStr)
    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.FIND_ID + type + paramStr + '&gbn=' + gbn,
      })
      .then(
        (response) => {
          dispatch(apiAction(authConstants.FIND_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(authConstants.FIND_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

/**
 * 비밀번호 찾기
 * @param type  : email or phone
 * @param params : JSON object
 */
function getFindPassword(type, params, gbn) {
  return (dispatch) => {
    dispatch(apiAction(authConstants.FIND_REQUEST))

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)
    paramStr.length > 0 && (paramStr = '?' + paramStr)

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.FIND_PW + type + paramStr + '&gbn=' + gbn,
      })
      .then(
        (response) => {
          dispatch(apiAction(authConstants.FIND_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(authConstants.FIND_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

/**
 * 정보찾기값 초기화
 * @returns {{type: string}}
 */
function resetFindInfo() {
  return { type: authConstants.RESET_FIND_INFO }
}

/**
 * API 액션 함수
 */
function apiAction(type, response = null) {
  let resultObj = { type }
  response && (resultObj.response = response)
  return resultObj
}

/**
 * API 통신 에러 문구 공통처리
 */
function apiError(error) {
  return alertActions.error({
    title: null,
    message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
  })
}

/**
 * 간편로그인
 * @param pinNum
 * @param deviceId
 * @returns {function(*): void}
 */
function passLogin(pinNum, deviceId) {
  return (dispatch) => {
    dispatch(apiAction(authConstants.PASS_LOGIN_REQUEST))
    authService.passLogin(pinNum, deviceId).then(
      (response) => {
        if (response.data?.payload?.authValue !== pinNum) {
          dispatch(passLoginFail(response))
          return
        }

        localStorage.setItem('user', JSON.stringify(response.data))
        document.location.href = '/'
      },
      (error) => {
        // dispatch(apiAction(authConstants.PASS_LOGIN_FAILURE, error))
        dispatch({type:authConstants.PASS_LOGIN_FAILURE, response: error})
        dispatch(apiError(error))
      },
    )
  }

  function passLoginFail(response) {
    return alertActions.error({
      title: null,
      message: response.data?.payload?.length > 0 ? response.data?.payload : errorMessages.passLoginFail,
    })
  }

  function pinNumFail(response) {
    return alertActions.success({
      title: '확인',
      message: response.data?.payload?.length > 0 ? response.data?.payload : errorMessages.pinEmptyYnStateError,
      params: {
        type: 'SUCCESS',
        callback: () => {
          window.location.replace('/LoginPassReset')
        },
      },
    })
  }
}

// 핀번호 재설정
function pinNumReset(pinNum, deviceId) {
  return (dispatch) => {
    dispatch(apiAction(authConstants.PIN_RESET_REQUEST))
    authService.pinNumReset(pinNum, deviceId).then(
      (response) => {
        if (response.data?.payload?.authValue != null) {
          dispatch(pinNumState(response))
          return
        }
      },
      (error) => {
        dispatch(apiAction(authConstants.PIN_RESET_FAILURE, error))
        dispatch(apiError(error))
      },
    )
  }

  function pinNumState(response) {
    return alertActions.success({
      title: '확인',
      message: response.data?.payload?.length > 0 ? response.data?.payload : errorMessages.pinNumState,
      params: {
        type: 'SUCCESS',
        callback: () => {
          window.location.replace('/LoginPass')
        },
      },
    })
  }
}

/**
 * 카카오로그인
 * @param param
 * @returns {function(*): void}
 */
function passkakaoLogin(param) {
  return (dispatch) => {
    dispatch(apiAction(authConstants.SNS_LOGIN_REQUEST))
    authService.passkakaoLogin(param).then(
      (response) => {
        localStorage.setItem('user', JSON.stringify(response.data))
        document.location.href = '/'
      },
      (error) => {
        dispatch(apiAction(authConstants.SNS_LOGIN_FAILURE, error))
        dispatch(passkakaoLoginFail(error))
      },
    )
  }
  function passkakaoLoginFail(error) {
    return alertActions.success({
      title: '확인',
      message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
      params: {
        type: 'SUCCESS',
        callback: () => {
          window.location.replace('/login')
        },
      },
    })
  }

  /* function passkakaoLoginFail(response) {
      return alertActions.error({
        title: null,
        message: response.data?.payload?.length > 0 ? response.data?.payload : errorMessages.passLoginFail
    })
  } */
}

/**
 * 카카오로그인 모바일
 * @param param
 * @returns {function(*): void}
 */
 function mobileKakaoLogin(param) {
  return (dispatch) => {
    dispatch(apiAction(authConstants.SNS_LOGIN_REQUEST))
    authService.mobileKakaoLogin(param).then(
      (response) => {
        localStorage.setItem('user', JSON.stringify(response.data))
        document.location.href = '/'
      },
      (error) => {
        dispatch(apiAction(authConstants.SNS_LOGIN_FAILURE, error))
        dispatch(passkakaoLoginFail(error))
      },
    )
  }
  function passkakaoLoginFail(error) {
    return alertActions.success({
      title: '확인',
      message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
      params: {
        type: 'SUCCESS',
        callback: () => {
          window.location.replace('/login')
        },
      },
    })
  }

  /* function passkakaoLoginFail(response) {
      return alertActions.error({
        title: null,
        message: response.data?.payload?.length > 0 ? response.data?.payload : errorMessages.passLoginFail
    })
  } */
}
/**
 * 네이버로그인
 * @param param
 * @returns {function(*): void}
 */
function passnaverLogin(param, state) {
  return (dispatch) => {
    dispatch(apiAction(authConstants.SNS_LOGIN_REQUEST))
    authService.passnaverLogin(param, state).then(
      (response) => {
        localStorage.setItem('user', JSON.stringify(response.data))
        document.location.href = '/'
      },
      (error) => {
        dispatch(apiAction(authConstants.SNS_LOGIN_FAILURE, error))
        dispatch(passnaverLoginFail(error))
      },
    )
    function passnaverLoginFail(error) {
      return alertActions.success({
        title: '확인',
        message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
        params: {
          type: 'SUCCESS',
          callback: () => {
            window.location.replace('/login')
          },
        },
      })
    }
  }
}

/**
 * 네이버로그인 모바일
 * @param param
 * @returns {function(*): void}
 */
 function mobileNaverLogin(param) {
  return (dispatch) => {
    dispatch(apiAction(authConstants.SNS_LOGIN_REQUEST))
    authService.mobileNaverLogin(param).then(
      (response) => {
        localStorage.setItem('user', JSON.stringify(response.data))
        document.location.href = '/'
      },
      (error) => {
        dispatch(apiAction(authConstants.SNS_LOGIN_FAILURE, error))
        dispatch(passnaverLoginFail(error))
      },
    )
    function passnaverLoginFail(error) {
      return alertActions.success({
        title: '확인',
        message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
        params: {
          type: 'SUCCESS',
          callback: () => {
            window.location.replace('/login')
          },
        },
      })
    }
  }
}


/******
 인증서 정보 전달(로그인) // 안드로이드 또는 웹
 *****/
function passCrtfctfLogin(param, gbn, mobileYn,makeSignData) {
  
  return (dispatch) => {
    dispatch(apiAction(authConstants.CRTFCT_LOGIN_REQUEST))
    authService.passcrtfctLogin(param, gbn, mobileYn).then(
      async (response) => {
        console.log(response.data.status)
        if (response.data.status === 200) {
          if(gbn != "3"){
            const user = response.data
            // user.payload.loginType = 'crtfctf'
            //alert("JSON.stringify(user) : "+JSON.stringify(user))
            //alert("user.payload.signData : "+user.payload.signData)
            localStorage.setItem('user', JSON.stringify(user))

            let raw = {moblphonNo:user?.payload?.mobileNo}
            let rspn = await getEcdeAdress(raw)
            console.log(rspn)
            if(rspn?.rspnsCode == '100' && makeSignData){
              user.payload.loginType = 'crtfctf'
              makeSignData(rspn.ecdwAdres)
              return
            } 
            document.location.href = '/'
          }
        } else {
          if(gbn != "3"){
            dispatch(passcrtfctLoginFail())
          }else if(gbn == "3"){
            dispatch(passcrtfctCehckFail())
          }
        }
      },
      (error) => {
        dispatch(apiAction(authConstants.CRTFCT_LOGIN_FAILURE, error))
        dispatch(apiError(error))
      },
    )
  }
  function passcrtfctLoginFail() {
    return alertActions.error({
      title: null,
      message: errorMessages.passcrtfctLoginFail,
    })
  }
  function passcrtfctCehckFail() {
    return alertActions.error({
      title: null,
      message: errorMessages.passcrtfctCehckFail,
    })
  }
}
function passCrtfctfLoginTest(param, gbn, mobileYn,makeSignData) {
  return (dispatch) => {
    dispatch(apiAction(authConstants.CRTFCT_LOGIN_REQUEST))
    authService.passcrtfctLogin(param, gbn, mobileYn).then(
      async (response) => {
        console.log(response.data.status)
        if (response.data.status === 200) {
          if(gbn != "3"){
            const user = response.data
            //alert("JSON.stringify(user) : "+JSON.stringify(user))
            //alert("user.payload.signData : "+user.payload.signData)
            localStorage.setItem('user', JSON.stringify(user))
            console.log(user)
            let raw = {moblphonNo:user?.payload?.mobileNo}
            let rspn = await getEcdeAdress(raw)
            console.log(rspn)
            if(rspn?.rspnsCode == '100'){
              user.payload.loginType = 'crtfctf'
              await makeSignData(rspn.ecdwAdres)
            } 
          }
        } else {
          if(gbn != "3"){
            dispatch(passcrtfctLoginFail())
          }else if(gbn == "3"){
            dispatch(passcrtfctCehckFail())
          }
        }
      },
      (error) => {
        dispatch(apiAction(authConstants.CRTFCT_LOGIN_FAILURE, error))
        dispatch(apiError(error))
      },
    )
  }
  
  function passcrtfctLoginFail() {
    return alertActions.error({
      title: null,
      message: errorMessages.passcrtfctLoginFail,
    })
  }
  function passcrtfctCehckFail() {
    return alertActions.error({
      title: null,
      message: errorMessages.passcrtfctCehckFail,
    })
  }
}
async function getEcdeAdress(rawJson){
  var myHeaders = new Headers()
  myHeaders.append('Content-Type', 'application/json')
  myHeaders.append('Accept', 'application/json')
  // 서버가 로그인 사용자의 CI 를 직접 조회하므로 토큰을 보낸다(로그인 직후라 localStorage 'user' 에 저장돼 있다).
  const authorization = authHeader().Authorization
  authorization && myHeaders.append('Authorization', authorization)
  let raw = JSON.stringify(rawJson)
  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  }
  
  let a = await fetch(uriConstants.API_URI + uriConstants.VERIFY_INDI_ECDW, requestOptions)
    .then((response) => response.text())
    .then((result) => {
      return JSON.parse(result)
    })
    return a?.payload
}

/******
 인증서 정보 전달(로그인) ios
 *****/
 function passCrtfctfLoginIos(param, gbn, mobileYn,makeSignData) {
  return (dispatch) => {
    dispatch(apiAction(authConstants.CRTFCT_LOGIN_REQUEST))
    authService.passcrtfctLoginIos(param, gbn, mobileYn).then(
      async (response) => {
        console.log(response.data.status)
        if (response.data.status === 200) {
          const user = response.data
          // user.payload.loginType = 'crtfctf'
          localStorage.setItem('user', JSON.stringify(user))

          let raw = {moblphonNo:user?.payload?.mobileNo}
          let rspn = await getEcdeAdress(raw)
          console.log(rspn)
          if(rspn?.rspnsCode == '100'&&makeSignData){
            user.payload.loginType = 'crtfctf'
            await makeSignData(rspn.ecdwAdres)
          } 
          // document.location.href = '/'
        } else {
          dispatch(passcrtfctLoginFail())
        }
      },
      (error) => {
        dispatch(apiAction(authConstants.CRTFCT_LOGIN_FAILURE, error))
        dispatch(apiError(error))
      },
    )
    dispatch(apiAction(authConstants.CRTFCT_LOGIN_REQUEST))
  }
  function passcrtfctLoginFail() {
    return alertActions.error({
      title: null,
      message: errorMessages.passcrtfctLoginFail,
    })
  }
}

/**
 * 디지털원패스 셋팅
 */
function callDgtOnePass() {
  return (dispatch) => {
    dispatch(apiAction(authConstants.DIGTOP_REQUEST))

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.DIGT_ONEPASS_INFO,
      })
      .then(
        (response) => {
          dispatch(apiAction(authConstants.DIGTOP_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(authConstants.DIGTOP_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

/**
 * 디지털원패스 로그인
 * @param param
 * @returns {function(*): void}
 */
function passonepassLogin(param) {
  return (dispatch) => {
    dispatch(apiAction(authConstants.SNS_LOGIN_REQUEST))
    authService.passonepassLogin(param).then(
      (response) => {
        localStorage.setItem('user', JSON.stringify(response.data))
        document.location.href = '/'
      },
      (error) => {
        dispatch(apiAction(authConstants.SNS_LOGIN_FAILURE, error))
        dispatch(passDigtOnePassFail(error))
      },
    )
  }
  function passDigtOnePassFail(error) {
    return alertActions.success({
      title: '확인',
      message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
      params: {
        type: 'SUCCESS',
        callback: () => {
          window.location.replace('/loginIntro')
        },
      },
    })
  }
}

/**
 * qr생성
 */
function qrMakeImg() {
  return (dispatch) => {
    dispatch(apiAction(authConstants.QRIMG_REQUEST))

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.QR_IMG_MAKE,
      })
      .then(
        (response) => {
          dispatch(apiAction(authConstants.QRIMG_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(authConstants.QRIMG_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

/**
 * qr 로그인체크
 * @param param
 * @returns {function(*): void}
 */
function qrLoginCheck(param) {
  return (dispatch) => {
    dispatch(apiAction(authConstants.SNS_LOGIN_REQUEST))
    authService.qrLoginCheck(param).then(
      (response) => {
        if (response.data.payload?.memberId !== null && response.data.payload?.memberId !== undefined) {
          localStorage.setItem('user', JSON.stringify(response.data))
          document.location.href = '/'
        }
      },
      (error) => {
        //dispatch(apiAction(authConstants.SNS_LOGIN_FAILURE, error))
        //dispatch(apiError(error))
      },
    )
  }

  function passQrLoginFail(error) {
    return alertActions.success({
      title: '확인',
      message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
      params: {
        type: 'SUCCESS',
        callback: () => {
          window.location.replace('/loginIntro')
        },
      },
    })
  }
}
/**
 * 간편 로그인
 * @param param
 * @returns {function(*): void}
 */
function simplLogin(param) {
  return (dispatch) => {
    dispatch(apiAction(authConstants.PASS_LOGIN_REQUEST))
    authService.simplLogin(param).then(
      (response) => {
        localStorage.setItem('user', JSON.stringify(response.data))
        document.location.href = '/'
      },
      (error) => {
        dispatch(apiAction(authConstants.PASS_LOGIN_FAILURE, error))
        dispatch(simplLoginFail(error))
      },
    )
  }
  function simplLoginFail(error) {
    return alertActions.success({
      title: '확인',
      message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
      params: {
        type: 'SUCCESS',
        callback: () => {
          window.location.replace('/loginIntro')
        },
      },
    })
  }
}

/**
 * 기기 고유번호 확인
 * @param param
 * @returns {function(*): void}
 */

function checkUUID(param) {
  return (dispatch) => {
    dispatch(apiAction(authConstants.MOBILE_UUID_REQUEST))

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.CHECK_UUID + '?deviceId=' + param,
      })
      .then(
        (response) => {
          dispatch(apiAction(authConstants.MOBILE_UUID_SUCCESS, response))
          console.log('uuid action', response)
        },
        (error) => {
          dispatch(apiAction(authConstants.MOBILE_UUID_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

function updateMemberApp(params, memberId, loginType) {
  return async (dispatch) => {
    dispatch(apiAction(mainConstants.MAIN_LOAD_REQUEST))

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)
    paramStr.length > 0 && (paramStr = '?' + paramStr)

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.UPDATE_PTL_MEMBER_APP + '/' + params + '/' + memberId + '/' + loginType,
      })
      .then(
        (response) => {
          dispatch(apiAction(mainConstants.MAIN_LOAD_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(mainConstants.MAIN_LOAD_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

function getDeviceId() {
  return (dispatch) => {
    dispatch(apiAction(authConstants.GET_DEVICE_ID_REQUEST))

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.GET_DEVICE_ID,
      })
      .then(
        (response) => {
          dispatch(apiAction(authConstants.GET_DEVICE_ID_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(authConstants.GET_DEVICE_ID_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

function apiSuccess(type, response) {
  return {
    type: type,
    response,
  }
}

function apiFailure(type, response) {
  return {
    type: type,
    response,
  }
}

function showPwdPopup(isShow, requestType, value) {

   return {
       type: authConstants.SHOW_PWD_POPUP,
       isShow: isShow,
       requestType: requestType,
       value: value,

   }
}

/******
 비밀번호 재확인 (Step-up)
 -----------------------------------------------------------------
 서버사이드로 변경 후 동작:
   - 일치   → HTTP 200 (응답 본문에 권한 정보 없음). 서버가 자체 메모리에 인증 시각 기록.
   - 불일치 → HTTP 401. axios가 reject 하므로 호출 측 catch에서 처리.
 즉 호출 측은 응답 body를 검사하지 않는다. throw 여부만으로 분기한다.
 *****/
function checkPwd(params) {
  return (dispatch) => {
    dispatch(apiAction(authConstants.PWD_REQUEST))
    // axios는 2xx만 then으로 보내고 그 외는 자동으로 reject한다.
    // 따라서 .then만 작성하고 실패는 호출 측에서 try/catch로 받게 한다.
    return defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + uriConstants.CHECK_PWD,
        params: { passwd: params },
      })
      .then((response) => {
        dispatch(apiAction(authConstants.PWD_SUCCESS, response))
        return response
      })
  }
}
